import React from 'react';

// Header used by the VerizonProgress<N> concepts: centered logo + account icon (BUZZ-3479).
const ProgressHeader = () => (
  <div className="email-progress_header">
    <svg className="email-progress_header-logo">
      <use xlinkHref="#svg_verizon-long-branded" />
    </svg>
    <svg className="email-progress_header-account">
      <use xlinkHref="#svg_account" />
    </svg>
  </div>
);

export default ProgressHeader;
